import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Reveal from './Reveal';
import { INTRO } from '../lib/data';
import { useLanguage } from '../lib/LanguageContext';
import { HOME_CONTENT } from '../lib/localizedContent';

const EditorialIntro = () => {
  const [noteOpen, setNoteOpen] = useState(false);
  const { language } = useLanguage();
  const content = HOME_CONTENT[language];
  return (
    <section
      id="about"
      className="bg-bone text-charcoal py-28 md:py-40 lg:py-48"
      data-testid="editorial-intro"
    >
      <div className="px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-x-6 gap-y-12">
          <Reveal className="col-span-12 md:col-span-2">
            <span className="text-[11px] tracking-eyebrow uppercase text-charcoal/60">
              {content.statementLabel}
            </span>
          </Reveal>

          <Reveal delay={0.1} className="col-span-12 md:col-span-10">
            <h2
              className="font-sans font-extrabold text-charcoal leading-[0.95] tracking-normal text-5xl sm:text-6xl md:text-7xl lg:text-[8vw]"
              data-testid="intro-headline"
            >
              {content.statementTitle.split('\n').map((line, i) => (
                <span key={i} className="block">
                  {line}
                </span>
              ))}
            </h2>
          </Reveal>

          <div className="col-span-12 md:col-start-7 md:col-span-6 mt-6 md:mt-16 space-y-6">
            {[content.statementBody].map((p, i) => (
              <Reveal key={i} delay={0.2 + i * 0.1}>
                <p className="text-charcoal/75 text-base md:text-lg leading-relaxed font-bold">
                  {p}
                </p>
              </Reveal>
            ))}
            <Reveal delay={0.5}>
              <button
                type="button"
                onClick={() => setNoteOpen((value) => !value)}
                aria-expanded={noteOpen}
                aria-controls="curatorial-note"
                data-testid="intro-cta"
                className="editorial-link mt-6 inline-flex"
              >
                <span>{noteOpen ? (language === 'ro' ? 'Închide nota' : 'Close curatorial note') : content.statementLink}</span>
                <motion.span className="arrow" animate={{ rotate: noteOpen ? 90 : 0 }}>→</motion.span>
              </button>
            </Reveal>
          </div>
        </div>
      </div>
      <AnimatePresence initial={false}>
        {noteOpen && (
          <motion.div
            id="curatorial-note"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ height: { duration: 0.8, ease: [0.16, 1, 0.3, 1] }, opacity: { duration: 0.45 } }}
            className="overflow-hidden"
          >
            <div className="px-6 md:px-12 lg:px-16 pt-24 md:pt-32">
              <div className="grid grid-cols-12 gap-6 border-t border-charcoal pt-10">
                <div className="col-span-12 md:col-span-8 md:col-start-5 space-y-6">
                  {content.curatorialNote.map((paragraph, index) => (
                    <motion.p
                      key={paragraph}
                      initial={{ opacity: 0, y: 18 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.7, delay: 0.18 + index * 0.09, ease: [0.16, 1, 0.3, 1] }}
                      className="text-base md:text-lg leading-relaxed text-charcoal/75"
                    >
                      {paragraph}
                    </motion.p>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default EditorialIntro;
